import { SubscriptionBackfillState } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/subscription_backfill_enums.pb';

export const BATCH_1_COMPLETE_STATES = [
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_BATCH1_COMPLETE,
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_BATCH2_IN_PROGRESS,
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_FULLY_COMPLETE,
];

export const BACKFILL_INCOMPLETE_STATES = [
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_PENDING,
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_BATCH1_IN_PROGRESS,
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_BATCH2_IN_PROGRESS,
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_WAITING_FOR_LIVE_CALLS,
  SubscriptionBackfillState.SUBSCRIPTION_BACKFILL_STATE_WAITING_RECORDING_DISABLED,
];

export const isBatch1Complete = (state?: SubscriptionBackfillState): boolean =>
  !!state && BATCH_1_COMPLETE_STATES.includes(state);

export const isBackfillIncomplete = (state?: SubscriptionBackfillState): boolean =>
  !!state && BACKFILL_INCOMPLETE_STATES.includes(state);
